import { coreType } from "./core-type.enum"

export const defaultCore = coreType.O_X5;

export class CoreType {
    type: coreType;
    bays: number;
    corridorWidth?: number;
    highrise: boolean;
    staircase: boolean;
    elevators: number;
    uiName: string;
}

export const coreTypesModel: CoreType[] = [
    {
        type: coreType.none,
        bays: 0,
        corridorWidth: 0,
        highrise: false,
        staircase: false,
        elevators: 0,
        uiName: ''
    },
    {
        type: coreType.O_X4,
        bays: 4,
        corridorWidth: 6.8,
        highrise: true,
        staircase: true,
        elevators: 1,
        uiName: 'Korte kern'
    },
    {
        type: coreType.O_X5,
        bays: 5,
        corridorWidth: 6.8,
        highrise: true,
        staircase: true,
        elevators: 1,
        uiName: 'Mid kern'
    },
    {
        type: coreType.O_X6,
        bays: 6,       
        corridorWidth: 6.8,
        highrise: true,
        staircase: true,
        elevators: 3,
        uiName: 'Lange kern',
    },
]
